module.exports = {"SearchBar":{"RecentSearches":"Recent searches"}}


//////////////////
// WEBPACK FOOTER
// ../i18n/en-au.json
// module id = ../i18n/en-au.json
// module chunks = client.sitechrome